(function (angular) {
    'use strict';

    angular.module('ui.order.newOrder.dataService', [])

        .service('newOrderDataService', function ($q, customResourceResolver, usersRepository) {

            angular.extend(this, {
                init: init,
                destroy: destroy,
                setDataProperty: setDataProperty
            });

            var _this = this;

            _this.currentUser = null;
            _this.newOrderConfig = null;
            _this.newOrderTypesConfig = null;
            _this.orderCreationAction = "";

            return _this;

            function init() {
                return $q.all([
                    initCurrentUser(),
                    initWorkflowConfig(),
                    initNewOrderConfig(),
                    initNewOrderTypesConfig()
                ]);
            }

            function destroy() {
            }

            function initCurrentUser() {
                return usersRepository.getCurrentUser()
                    .then(function (currentUser) {
                        _this.currentUser = currentUser;
                    });
            }

            function initWorkflowConfig() {
                return customResourceResolver.resolveWorkflow()
                    .then(function (workflowConfig) {
                        _this.orderCreationAction = workflowConfig.orderCreationAction;
                    });
            }

            function initNewOrderConfig() {
                return customResourceResolver.resolveNewOrder()
                    .then(function (newOrderConfig) {
                        _this.newOrderConfig = newOrderConfig;
                    });
            }

            function initNewOrderTypesConfig() {
                return customResourceResolver.resolveNewOrderTypes()
                    .then(function (newOrderTypesConfig) {
                        _this.newOrderTypesConfig = newOrderTypesConfig;
                    });
            }

            function setDataProperty(currentId, property, options) {
                if (currentId && property && options) {
                    property["@selectedOption"] = _.find(options, function (item) {
                        return currentId === item.id
                    }).title;
                    property["#text"] = currentId;
                }
            }
        });
})(window.angular);
